module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_green_de-a0cee86a2a48ab67ce741f7970774768.png";